<template>
  <div class="news-board-root-container" :class="{shown : shown}">
    <animatedBackground :IsShown="shown">
      <loadingIcon class="loading-icon-root" :shown="IsLoadingNews" />
      <particlesBackground class="top-and-simiTransparent" v-if="shown" />
      <div
        class="ErrorOccured"
        v-if="ErrorOccured && shown"
      >Error Occured while fetching the news, Please contact the owner</div>
      <div class="news-board-main-container">
        <div class="text-center header-closer-container" v-show="News">
          <h3 class="news-board-main-header" v-if="!Scrolled">Latest News</h3>
          <div class="close-btn-container" :class="{scrolled : Scrolled}">
            <div class="close-container" @click="$emit('closed')">
              <div class="leftright"></div>
              <div class="rightleft"></div>
              <label class="close-label">close</label>
            </div>
          </div>
        </div>

        <div class="container" v-show="News">
          <div class="row">
            <div class="col-lg-8 offset-lg-2 col-sm-12">
              <transition name="fade">
                <div class="CarouselCardContainer" v-show="News">
                  <CarouselCard :interval="7000" height="300px" type="card" arrow="always">
                    <CarouselCardItem v-for="item in Headlines" :key="item.url">
                      <a :href="item.url" target="_blank">
                        <img class="card-img-top" :src="item.urlToImage" alt="Card image cap" />
                        <div class="card-body">
                          <h6 class="card-title">{{item.title}}</h6>
                          <p class="card-text">
                            <small class="text-muted">
                              <i class="far fa-user"></i>
                              {{item.author}}
                              <i
                                class="fas fa-calendar-alt"
                              ></i>
                              {{ new Date(item.publishedAt).toDateString()}}
                            </small>
                          </p>
                        </div>
                      </a>
                    </CarouselCardItem>
                  </CarouselCard>
                </div>
              </transition>
            </div>
          </div>
          <div class="container cards-main-container" :class="{active : (News && shown)}">
            <transition-group tag="div" name="list">
              <div class="card-columns" v-for="(page , index) in News" :key="`page_${index}`">
                <div class="card" v-for="item in page" :key="item.url + index">
                  <a :href="item.url" target="_blank">
                    <img class="card-img-top" :src="item.urlToImage" alt="Card image cap" />
                    <div class="card-body">
                      <h6 class="card-title">{{item.title}}</h6>
                      <p class="card-text">{{item.content}}</p>
                      <p class="card-text">
                        <small class="text-muted">
                          <i class="far fa-user"></i>
                          {{item.author}}
                          <i class="fas fa-calendar-alt"></i>
                          {{ new Date(item.publishedAt).toDateString()}}
                        </small>
                      </p>
                    </div>
                  </a>
                </div>
              </div>
            </transition-group>
            <loadingIcon class="loading-icon-root addingNews" :shown="IsAddingNews" />
          </div>
        </div>
      </div>
    </animatedBackground>
  </div>
</template>

<script>
import loadingIcon from "../loading/loadingIcon";
import animatedBackground from "../animatedBackground";
import newsMixin from "../../mixins/newsMixin";
import { CarouselCard, CarouselCardItem } from "vue-carousel-card";
import particlesBackground from "../particlesBackground"
import "vue-carousel-card/styles/index.css";

export default {
  components: {
    loadingIcon,
    animatedBackground,
    CarouselCard,
    CarouselCardItem,
    particlesBackground
  },

  mixins: [newsMixin],

  props: ["shown"],

  data() {
    return {
      News: null,
      PageIndex: 1,
      NewsTotalLength: null,
      Headlines: null,
      IsLoadingNews: false,
      ErrorOccured: false,
      Scrolled: false,
      IsAddingNews: false,
    };
  },

  created: function () {},

  mounted: function () {
    var self = this;
    document.addEventListener("scroll", function () {
      self.Scrolled =
        document.documentElement.scrollTop &&
        document.documentElement.scrollTop > 5
          ? true
          : false;

      if (self.IsScrolledToButtom()) {
        self.RefreshNews();
      }
    });
  },

  watch: {
    shown: {
      immediate: true,
      handler(isShown) {
        //scroll to top when open news board

        this.News = null;
        if (isShown) {
          this.initialize();
          // delay the loader icon
          var self = this;
          setTimeout(() => {
            window.scrollTo(0, 0);
            self.IsLoadingNews = true;
          }, 2000);
        } else {
          this.IsLoadingNews = false;
        }
      },
    },
  },

  methods: {
    initialize: function () {
      var self = this;
      this.GetNews(
        this.PageIndex,
        function (response) {
          setTimeout(() => {
            var newsArray = [];
            newsArray.push(response.body.articles);
            self.News = newsArray;
            self.NewsTotalLength = response.totalResults;
            if (self.News && self.Headlines) {
              self.IsLoadingNews = false;
            }

            self.$forceUpdate();
          }, 3500);
        },
        function () {
          self.ErrorOccured = true;
        }
      );

      this.GetHeadlines(
        1,
        function (response) {
          setTimeout(() => {
            self.Headlines = response.body.articles;

            if (self.News && self.Headlines) {
              self.IsLoadingNews = false;
            }

            self.$forceUpdate();
          }, 3500);
        },
        function () {
          self.ErrorOccured = true;
        }
      );
    },

    IsScrolledToButtom: function () {
      var scrollTop =
        (document.documentElement && document.documentElement.scrollTop) ||
        document.body.scrollTop;

      // Grodriguez's fix for scrollHeight:
      // accounting for cases where html/body are set to height:100%
      var scrollHeight =
        (document.documentElement && document.documentElement.scrollHeight) ||
        document.body.scrollHeight;

      // >= is needed because if the horizontal scrollbar is visible then window.innerHeight includes
      // it and in that case the left side of the equation is somewhat greater.
      var scrolledToBottom =
        scrollTop + window.innerHeight >= scrollHeight - 200;

      return scrolledToBottom;
    },

    RefreshNews: function () {
      if (this.News && this.News.length >= this.NewsTotalLength) return;

      if (this.IsAddingNews) return;
      this.IsAddingNews = true;

      ++this.PageIndex;
      var self = this;
      this.GetNews(
        this.PageIndex,
        function (response) {
          setTimeout(() => {
            if (self.News) {
              var concatenatedArray = self.News;
              concatenatedArray.push(response.body.articles);
              self.News = concatenatedArray;
              self.IsAddingNews = false;
              self.$forceUpdate();
            }
          }, 3500);
        },
        function () {
          self.ErrorOccured = true;
        }
      );
    },
  },
};
</script>

<style >
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.CarouselCardContainer {
  margin-top: 120px;
  margin-bottom: 70px;
}
.CarouselCardContainer .card {
  background-color: initial;
}
.CarouselCardContainer .card-img-top {
  height: 100%;
  width: initial;
}

.CarouselCardContainer .card-body {
  position: absolute;
  bottom: 0px;
  background-color: #0000006e;
  background-image: linear-gradient(#23090e, #35114e);
  opacity: 0.9;
  width: 100%;
}

.CarouselCardContainer .carousel-card-item.is-active .card-body .card-title,
.CarouselCardContainer .carousel-card-item.is-active .card-body .card-text,
.CarouselCardContainer
  .carousel-card-item.is-active
  .card-body
  .card-text
  .text-muted {
  color: white !important;
}

.news-board-root-container .card-text {
  font-size: 12px;
}

.CarouselCardContainer .carousel-card-item.is-active .card-body .card-text {
  font-size: 12px;
}

.CarouselCardContainer
  .carousel-card-item.is-active
  .card-body
  .card-text
  .text-muted
  i {
  margin-left: 10px;
  margin-right: 4px;
}

.CarouselCardContainer .carousel-card-item a {
  text-decoration: none;
  color: white;
}
.CarouselCardContainer .carousel-card-item.is-active {
  background-image: linear-gradient(#840a1f, #240b36);
}

.CarouselCardContainer .carousel-card-mask {
  background-color: #000 !important;
  opacity: 0.64 !important;
}

.CarouselCardContainer .carousel-card-arrow {
  outline: none !important;
}

.list-enter-active,
.list-move {
  transition: 500ms cubic-bezier(0.59, 0.12, 0.34, 0.95);
  transition-property: opacity, transform;
}

.list-enter {
  opacity: 0;
  transform: translateX(50px) scaleY(0.5);
}

.list-enter-to {
  opacity: 1;
  transform: translateX(0) scaleY(1);
}

.news-board-root-container {
  position: absolute;
  width: 100%;
  height: 0%;
  top: 0;
  z-index: 99999999;
  animation-name: fadeOut;
  animation-duration: 0.4s;
  animation-timing-function: ease-in-out;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  opacity: 1;
}

.news-board-root-container.shown {
  height: 100%;
}

@-webkit-keyframes fade_ {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes fade_ {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.header-closer-container {
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
  margin-top: 40px;
  z-index: 99;
}

.news-board-main-header {
  color: #fbe1e9;
  padding: 10px 0;
  margin-bottom: 50px;
}

.card {
  /* -webkit-box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2); */
  /* box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2); */
  -webkit-transition: 0.3s;
  -o-transition: 0.3s;
  transition: 0.3s;
  border: none;
}
.card:hover {
  /* -webkit-box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.4); */
  /* box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.4); */
}
.card a {
  color: initial;
}
.card a:hover {
  text-decoration: initial;
}
.card .text-muted i {
  margin: 0 10px;
}

/********** close btn  */

.close-btn-container {
  position: absolute;
  top: 0px;
  right: 0px;
}

.close-container {
  position: relative;
  margin: auto;
  width: 50px;
  height: 50px;
  cursor: pointer;
}

.leftright {
  height: 4px;
  width: 30px;
  position: absolute;
  margin-top: 24px;
  background-color: white;
  border-radius: 2px;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
  -webkit-transition: all 0.3s ease-in;
  -o-transition: all 0.3s ease-in;
  transition: all 0.3s ease-in;
}

.rightleft {
  height: 4px;
  width: 30px;
  position: absolute;
  margin-top: 24px;
  background-color: white;
  border-radius: 2px;
  -webkit-transform: rotate(-45deg);
  -ms-transform: rotate(-45deg);
  transform: rotate(-45deg);
  -webkit-transition: all 0.3s ease-in;
  -o-transition: all 0.3s ease-in;
  transition: all 0.3s ease-in;
}

.close-btn-container.scrolled .leftright,
.close-btn-container.scrolled .rightleft {
  background-color: #f76270 !important;
}

label {
  color: white;
  font-family: Helvetica, Arial, sans-serif;
  font-size: 0.6em;
  text-transform: uppercase;
  letter-spacing: 2px;
  -webkit-transition: all 0.3s ease-in;
  -o-transition: all 0.3s ease-in;
  transition: all 0.3s ease-in;
  opacity: 0;
}

.close-label {
  margin: 51px 0 0 -26px;
  position: absolute;
}

.close-container:hover .leftright {
  -webkit-transform: rotate(-45deg);
  -ms-transform: rotate(-45deg);
  transform: rotate(-45deg);
  background-color: #f25c66;
}

.close-container:hover .rightleft {
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
  background-color: #f25c66;
}

.close-container:hover label {
  opacity: 1;
}

/* overrides */
.card-columns .card {
  margin-bottom: 1.75rem;
}

.news-list-toggle-container {
  position: absolute;
  width: 100%;
  left: 0px;
  bottom: -1000000px;
}

.news-list-toggle-container.active {
  bottom: initial;
  top: 0px;
}

.relative-positioned {
  position: relative;
}

.cards-main-container {
  margin-bottom: 350px;
}

.loader__icon.addingNews {
  position: relative;
  text-align: center;
  margin-top: 100px;
}

@media (min-width: 481px) and (max-width: 767px),
  (min-width: 320px) and (max-width: 480px),
  (min-width: 768px) and (max-width: 1024px) {
  .loader__icon.addingNews {
    margin-top: 150px;
  }
  .CarouselCardContainer {
    margin-top: 0px;
    margin-bottom: 70px;
  }

  .card-columns {
    -webkit-column-gap: 2.25rem;
    -moz-column-gap: 2.25rem;
    column-gap: 2.25rem;
  }

  .CarouselCardContainer .card-title {
    font-size: 12px;
  }

  .CarouselCardContainer .carousel-card-item.is-active {
    width: 80%;
    left: -14%;
    right: 0px;
  }
}
</style>